import React, { useEffect } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import TutorHeader from '../TutorHeader/TutorHeader'
import { getTutorReviewData } from '../../../Redux/action/TutorAction'
import { useDispatch, useSelector } from 'react-redux'
import Beatloader from '../../../Common/BeatLoader'
import { jwtDecode } from "jwt-decode";

const host = process.env.REACT_APP_API_SERVER
const TutorReview = () => {

    const dispatch = useDispatch();
    const token = localStorage.getItem('tutor-token')

    const decoded = jwtDecode(token);

    useEffect(() => {
        dispatch(getTutorReviewData(decoded?.user?.id));
    }, []);



    const {

        loadingTutorReviewDataApi,
        TutorReviewDataApiData,
        TutorReviewDataApiError

    } = useSelector(state => state?.TutorReducer);


    


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Ratings & Reviews
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorReviewDataApi ?
                                    <Beatloader />
                                    :
                                    <div className="dashboard-right-content">
                                        <h2 className="text-black">Ratings &amp; Reviews</h2>
                                        <div className="row w-100 ms-0">
                                            <div className="col-lg-2 col-md-2">
                                                <h2 className="text-black">{TutorReviewDataApiData?.avarageRating}</h2>
                                            </div>
                                            <div className="col-lg-10 col-md-10">
                                                <p className="mb-0 rating">
                                                    {Array.from({ length: 5 }, (_, index) => {
                                                        if (index < Math.floor(TutorReviewDataApiData?.avarageRating || 0)) {
                                                            return <i key={index} className="fas fa-star filled" />;
                                                        } else if (index < TutorReviewDataApiData?.avarageRating) {
                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                        } else {
                                                            return <i key={index} className="fas fa-star" />;
                                                        }
                                                    })}
                                                </p>
                                                <p>{TutorReviewDataApiData?.reviewCount} reviews</p>
                                            </div>
                                        </div>
                                        {/* <div className="row mb-2 w-100 ms-0">
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label active px-3">
                                                    <p className="mb-0 text-white">All</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label px-3">
                                                    <p className="mb-0 text-primary">1</p>
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label px-3">
                                                    <p className="mb-0 text-primary">2</p>
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label px-3">
                                                    <p className="mb-0 text-primary">3</p>
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label px-3">
                                                    <p className="mb-0 text-primary">4</p>
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 mb-2">
                                                <div className="star-rate-label px-3">
                                                    <p className="mb-0 text-primary">5</p>
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </div>
                                        </div> */}
                                        <p>Summary</p>
                                        <div className="row w-100 ms-0">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-1 col-1">
                                                        <p>5</p>
                                                    </div>
                                                    <div className="col-lg-9 col-md-9 col-5">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow={TutorReviewDataApiData?.ratingFiveCount}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                                style={{ width: `${(TutorReviewDataApiData?.ratingFiveCount / TutorReviewDataApiData?.totalratingCount) * 100}%` }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-5">
                                                        <p>{TutorReviewDataApiData?.ratingFiveCount ? TutorReviewDataApiData?.ratingFiveCount : '0'} Reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-1 col-1">
                                                        <p>4</p>
                                                    </div>
                                                    <div className="col-lg-9 col-md-9 col-5">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow={TutorReviewDataApiData?.ratingFourCount}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                                style={{ width: `${(TutorReviewDataApiData?.ratingFourCount / TutorReviewDataApiData?.totalratingCount) * 100}%` }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-5">
                                                        <p>{TutorReviewDataApiData?.ratingFourCount ? TutorReviewDataApiData?.ratingFourCount : '0'} Reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-1 col-1">
                                                        <p>3</p>
                                                    </div>
                                                    <div className="col-lg-9 col-md-9 col-5">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow={0}
                                                                aria-valuemin={0}
                                                                aria-valuemax={TutorReviewDataApiData?.ratingThreeCount}
                                                                style={{ width: `${(TutorReviewDataApiData?.ratingThreeCount / TutorReviewDataApiData?.totalratingCount) * 100}%` }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-5">
                                                        <p>{TutorReviewDataApiData?.ratingThreeCount ? TutorReviewDataApiData?.ratingThreeCount : '0'} Reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-1 col-1">
                                                        <p>2</p>
                                                    </div>
                                                    <div className="col-lg-9 col-md-9 col-5">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow={0}
                                                                aria-valuemin={0}
                                                                aria-valuemax={TutorReviewDataApiData?.ratingTwoCount}
                                                                style={{ width: `${(TutorReviewDataApiData?.ratingTwoCount / TutorReviewDataApiData?.totalratingCount) * 100}%` }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-5">
                                                        <p>{TutorReviewDataApiData?.ratingTwoCount ? TutorReviewDataApiData?.ratingTwoCount : '0'} Reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-1 col-1">
                                                        <p>1</p>
                                                    </div>
                                                    <div className="col-lg-9 col-md-9 col-5">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow={0}
                                                                aria-valuemin={0}
                                                                aria-valuemax={TutorReviewDataApiData?.ratingOneCount}
                                                                style={{ width: `${(TutorReviewDataApiData?.ratingOneCount / TutorReviewDataApiData?.totalratingCount) * 100}%` }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-5">
                                                        <p>{TutorReviewDataApiData?.ratingOneCount ? TutorReviewDataApiData?.ratingOneCount : '0'} Reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <p className="fw-bold">All</p>
                                            </div>
                                            <div>
                                                <p className="fw-bold">
                                                    Most Recent{" "}
                                                    <i className="fa-solid fa-chart-simple text-primary ms-2" />
                                                </p>
                                            </div>
                                        </div>
                                        {TutorReviewDataApiData?.data?.map((data) => (
                                            <div className="row mb-3">
                                                <div className="col-lg-2 col-md-2 pb-2 pe-4">
                                                    <img
                                                        src={`${host}${data?.student?.profile_img}`}
                                                        className="img-fluid rounded"
                                                        style={{ height: 78, width: "auto" }}
                                                        onError={(e) => {
                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-7 pt-2">
                                                    <h5 className="mb-0">{data?.student?.name}</h5>
                                                    <p className="mb-0 rating">
                                                        {Array.from({ length: 5 }, (_, index) => {
                                                            if (index < Math.floor(data?.rating || 0)) {
                                                                return <i key={index} className="fas fa-star filled" />;
                                                            } else if (index < data?.rating) {
                                                                return <i key={index} className="fas fa-star-half-alt filled" />;
                                                            } else {
                                                                return <i key={index} className="fas fa-star" />;
                                                            }
                                                        })}
                                                    </p>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-4 pt-2">
                                                    <h5 className="mb-0">{new Date(data?.createdAt).toISOString().split('T')[0]}</h5>
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-12">
                                                    <p className="mb-0">{data?.review}</p>
                                                </div>
                                            </div>
                                        ))}

                                    </div>}
                            </main>




                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorReview